import React, { Component } from 'react';
import StorageContainer from './StorageContainer.js';
import {Container,Row} from 'react-bootstrap';
//import StorageTypes from "./StorageTypes.js";

// base class to inventory search
// lookup inventory and display in the storage container:

class Inventory extends Component {

    mount() {
        // props will provide (or provided by url if hard coded links are required):
        //      character *required, ex: {"BillyBobSnarkyPants"}
        //      server *required, ex: {"Sarlona"}
        //      storagetype *required, ex: {Bank}
        //      search optional
        //      index optional

        // if there is no search or index, search the storage type for all items and display the entire list
        // if we have a search, use all and display the entire list
        // if we have an index then we should NOT have a search either, we will lookup an individual item
        
        // first see if they were passed in as parameters to props:
        let { character, server, storagetype, search, index } = this.props;

        // if not, later (todo?) we could try to missing values from above parameters, directly from the url

        // if we did not get the required search keys above, bomb out
        if (character === undefined || server === undefined || storagetype === undefined) {
            // fail, set error to render before everyting else.
            this.setState({ error: "Error: Not enough parameters - Character, Server, and Storage type are required." });
        }

        // search term
        if (search !== undefined) {
            
        } 
        // individual
        else if (index !== undefined) {
            
        } 
        // search type
        else
        {

        }
    }


    render() {
        // we need some item data in a list to use as a paramater (prop) to the storagecontainer
        let { itemList, error } = this.state;

        return (
            <Container>
                <Row>
                    {error ? <div>There was an error processing your request, {error} please review and try again.</div>
                    : <StorageContainer items={itemList} /> }
                </Row>
            </Container>
        );
    };
}

export default Inventory;